export const TemplateDowngrade = (accounting, downgrade) =>
    `
<table
style="
  font-family: Open Sans, sans-serif;
  width: 100%;
  color: #2e5573;
  font-size: 16px;
"
>
<tbody>
  <tr>
    <td valign="top">
      <table
        cellpadding="0"
        cellspacing="0"
        border="0"
        style="
          height: 4px;
          width: 100%;
          background-color: #00cbd2;
          margin-bottom: 24px;
        "
      >
        <tbody>
          <tr></tr>
        </tbody>
      </table>
      <h1
        style="
          text-align: center;
          font-size: 24px;

          margin: 0;

          font-family: Open Sans, sans-serif;
        "
      >
            Solicitação de mudança de plano (Downgrade) <br>
           (${accounting.superLogicaId})  ${accounting.name}
      </h1>
      <table
        border="0"
        cellpadding="0"
        cellspacing="0"
        width="100%"
        style="
          font-size: 0;
          height: 30px;
          width: 100%;
          min-width: 100%;
          line-height: 0;
        "
      >
        <tbody>
          <tr>
            <td height="30">
              <span
                style="
                  color: transparent;
                  background: none;
                  text-overflow: ellipsis;
                  opacity: 0;
                  width: 100%;
                  min-width: 100%;
                  height: 1;
                  padding: 0;
                  font-size: 0;
                "
              >
                &nbsp;</span
              >
            </td>
          </tr>
        </tbody>
      </table>

      <p style="color: #2e5573; font-family: Open Sans, sans-serif">
        A Contabilidade  ${accounting.name}  realizou uma solicitação de mudança de plano!! <b>(Downgrade)</b>.
      </p>
    </td>
  </tr>
  <tr>
    <td>
      <p><strong>Código no Hubspot:</strong> ${accounting.hubspotId}</p>
      <p><strong>Código da Nucont:</strong> ${accounting.superLogicaId}</p>
      <p>
        <strong>Email Financeiro:</strong>
        ${accounting.financialEmail}
      </p>

      <p><strong>Dono da Venda:</strong> ${accounting.seller}</p>

      <p><strong>Data da Venda:</strong> ${accounting.createdAt} </p>

      
    </td>
  </tr>
  <tr>
    <td>
     
     <p><strong>Solicitação:</strong></p>

       <ul>
        <li> <p><strong>Motivo do Downgrade :</strong> ${downgrade.change}</p></li>
        <li> <p><strong>Informação acrescentada :</strong> ${downgrade.information}</p></li>
      </ul>

     
     
      <table
        cellpadding="0"
        cellspacing="0"
        border="0"
        style="
          height: 2px;
          width: 100%;
          background-color: #e8e7e6;
          margin-bottom: 24px;
        "
      >
        <tbody>
          <tr></tr>
        </tbody>
      </table>


     
     <p><strong>Contrato Atual:</strong></p>

      <ul>
        <li> 
          <p><strong>Plano:</strong> ${accounting.contract}  </p>
        </li>
        <li>
          <p><strong>Qtd. de Empresas:</strong> ${accounting.countCompany}</p>
        </li>
        <li>
          <p><strong>Status Interno:</strong> ${accounting.internalStatus}</p>
        </li>
        <li>
          <p>
            <strong>Status Superlogica:</strong> ${accounting.superlogicaStatus}
          </p>
        </li>
      </ul>
    </td>
  </tr>
</tbody>
</table>
`;
